const default_address = (state = null, action: any) => {
	switch(action.type) {
		case 'SET_DEFAULT_ADDRESS':
            return action.payload || null;
            break;
        default: 
        	return state;
        	break;
	}
}

export default default_address;